import { render, staticRenderFns } from "./MassiveEvents.vue?vue&type=template&id=5405a50b&scoped=true"
import script from "./MassiveEvents.vue?vue&type=script&lang=js"
export * from "./MassiveEvents.vue?vue&type=script&lang=js"
import style0 from "./MassiveEvents.vue?vue&type=style&index=0&id=5405a50b&prod&lang=css"
import style1 from "./MassiveEvents.vue?vue&type=style&index=1&id=5405a50b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5405a50b",
  null
  
)

export default component.exports